// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".save-btn-con[data-v-0a9a5056]{margin-top:35px}.saveTips[data-v-0a9a5056]{color:#999;font-size:12px;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
